export const lightTheme = {
    primaryorange: "#F7707D",
    secorange: "#F29173",
    text1: "#1e1e2d",
    text2: "#71717a",
    textInvert: "rgb(245, 245, 245)",
    textInvert2: "rgb(210, 210, 210)",
    primary1: "#F7707D",
    primary2: "#252c49",
    bg: "#1e1e2d",
    bg2: "#f4f4f5",
    bg3:"#22c55e",
    bg4:"rgba(255, 255, 255, 0.95)",
    bg5:"#ffffff",
    bg6:"#fafafa",
    hover:"#f0fdf4",
    gray: "#d4d4d8",
    buttbg:"linear-gradient(135deg, #F7707D 0%, #F29173 100%)",

    breakpoint:{
        m: "(max-width : 48rem) and (min-width : 30.1rem)",
        s: "(max-width : 30rem)"
    }
};

export const darkTheme = {
    text: "rgb(245, 245, 245)",
    text2: "rgb(210, 210, 210)",
    textInvert: "rgb(20, 20, 20)",
    textInvert2: "rgb(55, 55, 55)",
    primary: "rgb(200, 117, 196)",
    primary2: "rgb(200, 117, 147)",
    bg: "rgb(3, 3, 3)",
    bg2: "rgb(30,30,30)",
};
